import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Box,
  IconButton,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Edit } from '@mui/icons-material';
import { fetchAllQuotes } from "./../../actions/quoteActions";
import LoadingBackdrop from "../Common/LoadingBackdrop";

const QuotesTable = ({ searchText = "" }) => {
  const dispatch = useDispatch();
  const all_quotes = useSelector((state) => state.quotes.all_quotes);
  const loading = useSelector((state) => state.quotes.isLoading);

  useEffect(() => {
    dispatch(fetchAllQuotes());
  }, [dispatch]);

  const filteredQuotes = all_quotes?.filter(quote =>
    quote.quote_text.toLowerCase().includes(searchText.toLowerCase()) ||
    (quote.quote_speaker_name && quote.quote_speaker_name.toLowerCase().includes(searchText.toLowerCase()))
  );

  if (loading) {
    return <LoadingBackdrop />;
  }

  return (
    <Box sx={{ py: 2 }}>
      <TableContainer
        component={Paper}
        sx={{
          marginTop: 3,
          boxShadow: 2,
          borderRadius: 1,
          overflow: 'hidden'
        }}
      >
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell><strong>Quote</strong></TableCell>
              <TableCell align="right"><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredQuotes?.length === 0 ? (
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ py: 4 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                    {searchText ? "No quotes found matching your search" : "No quotes available"}
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              filteredQuotes?.map((quote) => (
                <TableRow
                  key={quote.quote_id}
                  sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}
                >
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                      <Typography variant="subtitle1">{quote.quote_text}</Typography>
                      {quote.quote_speaker_name && (
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontStyle: 'italic' }}
                        >
                          — {quote.quote_speaker_name}
                        </Typography>
                      )}
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                      <Tooltip title="Edit">
                        <IconButton
                          component={Link}
                          to={`/quotes/edit/${quote.quote_id}`}
                          sx={{ '&:hover': { backgroundColor: 'action.hover' } }}
                        >
                          <Edit />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default QuotesTable;
